import { render, staticRenderFns } from "./customer-case.vue?vue&type=template&id=4df5a5fc&scoped=true"
import script from "./customer-case.vue?vue&type=script&lang=js"
export * from "./customer-case.vue?vue&type=script&lang=js"
import style0 from "./customer-case.vue?vue&type=style&index=0&id=4df5a5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5a5fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomItem: require('/builds/wj/fe/wenjuan-homesite/components/common/custom-item.vue').default,CommonCarouselStep: require('/builds/wj/fe/wenjuan-homesite/components/common/carousel-step.vue').default,CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default,CommonWrap: require('/builds/wj/fe/wenjuan-homesite/components/common/wrap.vue').default})
